import React, { useEffect } from 'react';
import { ApolloProvider } from 'react-apollo';
import { useDispatch } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';

import 'react-responsive-modal/lib/react-responsive-modal.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { appClient } from './config/apollo';
import { history } from './config/history';
import { Dispatch } from './config/rootStore';
import { InviteDependentModal } from './modules/user/components/InviteDependentModal';
import { Routes } from './routing/Routes';
import { MobileAppInformationModal } from './shared/components/MobileAppInformationModal';
import { PageNotFound } from './shared/components/PageNotFound';
import { ToastContainer } from './shared/ds';

export const Root = () => {
    const dispatch: Dispatch = useDispatch();
    useEffect(() => {
        dispatch.countries.fetchCountries();
    }, []);

    return (
        <>
            <Router history={history}>
                <ApolloProvider client={appClient}>
                    <Switch>
                        <Routes />
                        <Route component={PageNotFound} />
                    </Switch>

                    <InviteDependentModal />
                    <MobileAppInformationModal />
                    <ToastContainer />
                </ApolloProvider>
            </Router>
        </>
    );
};
